module.exports =
  mockupTemplate:
    byIdentifier: '/mockupTools/mockupTemplate/byIdentifier/:identifier'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/mockupTools.coffee